import { REQUIRED_COARSE_SCOPES, REQUIRED_GRANULAR_SCOPES } from './constants';
export var useScopeChecks = function useScopeChecks(appInstallationScopes) {
  if (appInstallationScopes) {
    var appHasAllRequiredCoarseScopes = REQUIRED_COARSE_SCOPES.every(function (requiredScope) {
      return appInstallationScopes.includes(requiredScope);
    });
    if (appHasAllRequiredCoarseScopes) {
      return true;
    }
    return REQUIRED_GRANULAR_SCOPES.every(function (requiredScope) {
      return appInstallationScopes.includes(requiredScope);
    });
  }
  return false;
};